import { render, staticRenderFns } from "./TaskDetailsPopup.vue?vue&type=template&id=7d29c024&"
import script from "./TaskDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./TaskDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailsPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VDialog,VFadeTransition})
